import { Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UsuarioService } from 'src/app/_services/usuario.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { DiasRestantesComponent } from 'src/app/_shared/bloque-ficha/dias-restantes/dias-restantes.component';
import { ProgressBarComponent } from 'src/app/_shared/bloque-ficha/progress-bar/progress-bar.component';
import { OportunidadRealEstate } from 'src/app/home/_models/oportunidad-realestate';
import { TagEstadoRondaComponent } from 'src/app/realestate/shared/tag-estado-ronda/tag-estado-ronda.component';
import { UbicacionProyectoComponent } from 'src/app/realestate/shared/ubicacion-proyecto/ubicacion-proyecto.component';

@Component({
  selector: 'app-ficha-home',
  templateUrl: './ficha-home.component.html',
  styleUrls: ['./ficha-home.component.scss'],
  standalone: true,
  imports:[
    SharedModule,
    RouterModule,
    TagEstadoRondaComponent,
    UbicacionProyectoComponent,
    DiasRestantesComponent,
    ProgressBarComponent
  ]
})

export class FichaHomeComponent implements OnInit {

  @Input() isLogged: boolean;
  @Input() oportunidadRealEstate: OportunidadRealEstate;
  @Input() domainUrl: string;
  @Input() target: string;
  isDiasRestantesFinanciado: boolean;

  constructor(
    private _usuarioService: UsuarioService,
  ) { }

  ngOnInit(): void {
    this.checkDiasRestantes();
  }

  getBaseUrl(): string {
    var url = this._usuarioService.getSession() ? '/panel-inversor/proyecto/' : '/';
    return url;
  }

  private checkDiasRestantes(): void {
    this.isDiasRestantesFinanciado = (this.oportunidadRealEstate.tipoEstadoRondaId === 'financiado' || this.oportunidadRealEstate.tipoEstadoRondaId === 'devuelto') ? true : false;
  }
}
